<template>
<div class="blog-container" :class="'route-'+$route.name" :style="{height: $parent.isMobile ? undefined : innerHeight + 'px', paddingLeft: $parent.isMobile ? '0px' :undefined, paddingRight: $parent.isMobile ? '0px' : undefined}">
    <template v-if="$parent.isMobile">
        <router-view name="mobile">
        </router-view>
    </template>

    <vs-row justify="flex-end" v-if="user != null && user.is_admin && !$parent.isMobile" style="position: fixed; top: 50px; right: 50px; width: 100%;">
        <!-- Admin create button disabled (blog now managed via WordPress) -->
        <vs-button size="large" disabled title="Gestisci gli articoli dal pannello WordPress">Crea Nuovo</vs-button>
    </vs-row>

    
    <div class="blog-posts" v-if="!$parent.isMobile && ($route.name == 'Blog' || $route.name == 'Post') || ($parent.isMobile && $route.name == 'Blog')" :style="{width: $parent.isMobile ? '100%' : undefined}" :class="{'blog-posts-mobile': $parent.isMobile}">
        <div class="header" v-if="!$parent.isMobile">
            <h2 style="margin: 0;">{{ $t('blog.title') }}</h2>
            <p style="margin: 0;">{{ $t('blog.caption') }}</p>
        </div>
        <div class="header" style="align-items: flex-start; padding: 0 15px; margin: 0; box-sizing: border-box;" v-else>
            <img src="@/assets/images/logo.png" style=" height: 32px;" />
            <h2 style="margin: 0; font-weight: 600;">{{ $t('blog.mobileCaption') }}</h2>
        </div>
        <vs-row style="padding: 0 10px; max-height: 86px; overflow-y: hidden;" v-if="$parent.isMobile">
<vs-button
  v-for="tag in tags"
  :key="'tag-' + tag.id"
  @click="toggleTag(tag.id)"
  :dark="!selected_tags.includes(tag.id)"
>
  #{{ tag.name }}
</vs-button>
            
        </vs-row>
        <PostPreview :user="user" v-for="article in articles" :article="article" :key="'article-' + article.id" @click.native="$router.push({path: '/blog/post/' + (article.slug != null && article.slug != '' ? article.slug : article.id)})" />
    </div>
</div>
</template>

<script>
import axios from 'axios';
import BreadCumbWrapper from '../components/BreadCumbWrapper.vue';
import PostPreview from '../components/PostPreview.vue';
import Post from '../components/elements/Post.vue';
import getEnv from '../utils/env.js';
import { toWpmlLocale, localeReadiness } from '../utils/wpmlLocale.js';

function wpBaseUrl() {
    return (getEnv('WP_BLOG_URL') || 'https://tourial.it/blog').replace(/\/+$/, '');
}

export default {
    name: 'App',
    components: {
        PostPreview,
    },

    props: {
        user: {
            type: Object,
            default: null
        },

        userLoaded: {
            type: Boolean,
            default: false
        },

        innerHeight: {
            type: Number,
            default: 100,
            required: false
        }
    },

    data() {
        return {
            articles: [],
            panel: null,
            tags: [],
            selected_tags: [],

            /* DIALOGS */

            dialogComponent: null,

            currentPage: 1,
            totalPages: 1,
            loading: false

        }
    },

    computed: {
        // `null` until the app has resolved the final active language (see
        // src/utils/wpmlLocale.js); fetching before that would risk one
        // request with a provisional locale followed by another with the
        // real one. Once ready, this is either a WPML language code or ''
        // for Italian (WPML's default, which must be requested with no
        // `lang` param at all — see toWpmlLocale()).
        wpmlLang() {
            if (!localeReadiness.ready) return null;
            return toWpmlLocale(this.$i18n.locale) || '';
        }
    },

    created() {

    },
    beforeDestroy() {

    },

    mounted() {
        if (this.$route.name != 'Blog') { // l'utente sta provando a visitare direttamente una sotto-rotta (eg. visitando viaggi da contact-us)
            this.showRoute(this.$route)
        }
        this.getBlogTags();
        if (this.wpmlLang != null) {
            this.getBlogArticles();
        }

        let el = document.getElementsByClassName('blog-container')[0];
        el.onscroll = () => {
            let e = document.getElementsByClassName('blog-container')[0];
            let bottomOfWindow = Math.abs(e.scrollTop - (e.scrollHeight - e.offsetHeight)) < 20;
            if (bottomOfWindow) {
                if (this.currentPage < this.totalPages && !this.loading) {
                    this.currentPage++;
                    this.getBlogArticles(false);
                }
            }
        };
    },

    methods: {
        toggleTag(tagId) {
            const idx = this.selected_tags.indexOf(tagId);
            if (idx === -1) {
                this.selected_tags = [tagId]; // reset to only this tag
            } else {
                this.selected_tags.splice(idx, 1);
            }
            this.currentPage = 1;
            this.getBlogArticles();
        },

        async getBlogTags() {
            try {
                let url = wpBaseUrl() + '/wp-json/wp/v2/tags?per_page=100&hide_empty=true';
                // Follow the active language so the tag chips are translated too
                // (mirrors getBlogArticles). Without &lang= WPML returns the
                // default-language (Italian) tags regardless of the UI locale.
                if (this.wpmlLang) {
                    url += '&lang=' + this.wpmlLang;
                }
                const response = await axios.get(url);
                if (response.status === 200 && Array.isArray(response.data)) {
                    this.tags = response.data.map(t => ({
                        id: t.id,
                        name: this.decodeHtmlEntities(t.name)
                    }));
                }
            } catch (e) {
                console.error('Failed to load WP tags:', e);
            }
        },

        async getBlogArticles(reset = true) {
            this.loading = true;
            const loading = this.$vs.loading();

            if (this.panel != null && reset) {
                await this.panel.hide();
                this.panel = null;
            }

            try {
                let url = wpBaseUrl() + '/wp-json/wp/v2/posts?per_page=5&page=' + this.currentPage + '&_embed&orderby=date&order=desc';
                if (this.wpmlLang) {
                    url += '&lang=' + this.wpmlLang;
                }

                // Filter by tag if selected
                if (this.selected_tags && this.selected_tags.length > 0) {
                    url += '&tags=' + this.selected_tags.join(',');
                }

                const response = await axios.get(url);

                if (response.status === 200 && Array.isArray(response.data)) {
                    // Map WP posts to the format our components expect
                    const mapped = response.data.map(post => this.mapWpPost(post));

                    if (reset) {
                        this.articles = mapped;
                    } else {
                        this.articles = this.articles.concat(mapped);
                    }

                    // Get total pages from WP response headers
                    this.totalPages = parseInt(response.headers['x-wp-totalpages'] || '1', 10);
                }
            } catch (e) {
                console.error('Failed to load WP posts:', e);
                if (reset) {
                    this.articles = [];
                }
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: this.$t('blog.messages.cannotLoadPosts'),
                    color: 'danger',
                    position: 'top-right'
                });
            }

            loading.close();
            this.loading = false;
        },

        /**
         * Decode HTML entities (e.g. &#8217; → ') returned by WordPress REST API.
         */
        decodeHtmlEntities(str) {
            if (!str) return str;
            const txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value;
        },

        /**
         * Map a WP REST API post object to the format expected by PostPreview and Post components.
         */
        mapWpPost(post) {
            // Extract featured image URL from _embedded
            let pictureUrl = null;
            if (post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0]) {
                const media = post._embedded['wp:featuredmedia'][0];
                pictureUrl = media.source_url || null;
            }

            // Extract tags (post_tag taxonomy)
            const tags = [];
            if (post._embedded && post._embedded['wp:term']) {
                post._embedded['wp:term'].forEach(termGroup => {
                    termGroup.forEach(term => {
                        if (term.taxonomy === 'post_tag') {
                            tags.push(this.decodeHtmlEntities(term.name));
                        }
                    });
                });
            }

            // Extract meta description from Yoast SEO or excerpt
            let metaDescription = '';
            if (post.yoast_head_json && post.yoast_head_json.description) {
                metaDescription = post.yoast_head_json.description;
            } else if (post.excerpt && post.excerpt.rendered) {
                // Strip HTML from excerpt
                metaDescription = post.excerpt.rendered.replace(/<[^>]+>/g, '').trim();
            }

            return {
                id: post.id,
                title: this.decodeHtmlEntities(post.title.rendered),
                text: post.content.rendered,
                slug: post.slug,
                updated_at: post.date,
                picture_url: pictureUrl,
                picture_id: null, // No S3 — image URL is direct
                tags: tags,
                meta_description: metaDescription,
                published: post.status === 'publish',
                _wp_source: true // flag to indicate this is from WP
            };
        },

        showRoute(n) {
            console.log('Blog showing ' + n.name)
            // do nothing from mobile
            if (this.$parent.isMobile) {
                return;
            }
            
            if (this.panel != null) {
                this.panel.hide();
                this.panel = null;
            }
            if (!n.meta.side) {

                return;
            }

            setTimeout(() => {
                this.panel = this.$showPanel({
                    component: BreadCumbWrapper,
                    openOn: 'right',
                    removeBg: true,
                    cssClass: 'blog-post-panel',
                    props: {
                        component: Post,
                        name: this.$t('routes.Blog'),
                        back: () => {
                            this.$router.replace({path: '/blog'})
                        },
                        user: this.user,
                        params: {
                            deleted: this.getBlogArticles
                        }
                    }
                });

                this.panel.promise
                .then(result => {
                    if (this.panel != null && this.panel.id == result.id) { // c'è un panel aperto, ed è lo stesso che si sta chiudendo
                        this.$router.push('/blog/')
                        this.panel = null;
                    }
                });

            }, 750);

            // disable overflow-y of .blog-container
            let el = document.getElementsByClassName('blog-container')[0];
            el.style.overflow = 'hidden';

            
        }
    },

    watch: {
        '$route'(n) {
            this.showRoute(n);
        },

        wpmlLang(n) {
            if (n == null) return; // still waiting for the locale to settle; mounted()/the readiness flip will fetch
            // Re-fetch so the WPML `lang` param follows the language the user just switched to.
            this.currentPage = 1;
            // Tag IDs are per-language in WPML, so a filter selected in the
            // previous language would no longer match; reset it on switch.
            this.selected_tags = [];
            // Re-fetch the tags too so the chips follow the new language.
            this.getBlogTags();
            this.getBlogArticles();
        },

        panel(n) {
            // if n is not null block scrolling of page .blog-containe
            let el = document.getElementsByClassName('blog-container')[0];
            if (n != null) {
                el.style.overflow = 'hidden';
            } else {
                el.style.overflow = 'auto';
            }
        }
    }
}
</script>
<style>
.blog-posts-mobile .vs-card-content {
    width: 100%!important;
    max-width: unset!important;
}

.blog-posts-mobile .vs-card-content .vs-card {
    width: 98%!important;
    max-width: unset!important;
    margin-left: 1%!important;
}
.blog-post-panel {
    width: calc(100% - 600px) !important;
    max-width: calc(100% - 600px) !important;
}
</style>
<style scoped>
.header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin-bottom: 10px;
}

.blog-posts {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.blog-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-left: 80px;
    box-sizing: border-box;

}

.blog-posts .vs-card-content.type-1 {
    max-width: 350px;
}



/* MOBILE */
@media (max-width: 600px) {
    .blog-container {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        box-sizing: border-box;
        padding-bottom: 100px;
        height: unset !important;
        overflow: visible !important;
    }

    .blog-posts {
        padding-top: 20px;
        width: 100%;
    }
}
</style>
